module.exports = __webpack_public_path__ + "static/media/bg_feature_1.5288b9a6.jpg";